import { useQueryClient } from '@tanstack/react-query'
import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { AgreementStatus, Product } from '../typing'
import { useMutationHook } from './mutationHook'

interface IUpdateAgreementParams {
  id: string
  authorPhone: string
  typeId: string
  substitutions?: {
    [key: string]: string
  }
  products?: string[]
}

interface IUpdateAgreementResponse {
  id: string
  authorId: string
  authorPhone: string
  status: AgreementStatus
  typeId: string
  typeName: string
  substitutions: {
    [key: string]: string
  }
  products: Product[]
  createdAt: string
}

async function fetchUpdateAgreement(path: string, body: IUpdateAgreementParams) {
  const { data } = await apiPost<IUpdateAgreementParams, IUpdateAgreementResponse>({ path, body })

  return data
}

export const useUpdateAgreement = (options?: {
  onSuccess?: (data: IUpdateAgreementResponse) => void
  onError?: (error: Error) => void
}) => {
  const queryClient = useQueryClient()
  const path = API_ROUTES.AGREEMENT_UPDATE
  const mutationFn = (url: string, body: IUpdateAgreementParams) => fetchUpdateAgreement(url, body)

  const mutationFunc = useMutationHook({
    path,
    mutationKey: [path],
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AGREEMENTS],
      })
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AGREEMENT_GET, data.id],
      })
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AGREEMENT_ADMIN_GET, data.id],
      })
      options?.onSuccess?.(data)
    },
    onError: options?.onError,
  })

  return mutationFunc
}
